import React, { useState } from 'react';
import axios from 'axios';

const RemoveGroup = ({ groupId, groupName, onRemove, groupType, cteTeacher }) => {
    const [isConfirming, setIsConfirming] = useState(false);

    const handleRemove = async () => {
        try {
            let endpoint = '';
            let requestConfig = {
                headers: { 'X-CSRFToken': document.cookie.match(/csrftoken=([^;]*)/)?.[1] },
            };

            // Determine endpoint based on group type
            if (groupType === 'core') {
                endpoint = `/api/groups/core-groups/${groupId}/`;
            } else if (groupType === 'cte') {
                endpoint = `/api/groups/cte-groups/${groupId}/`;
                // Include cte_teacher if provided for CTE groups
                if (cteTeacher) {
                    requestConfig.params = { cte_teacher: cteTeacher };
                }
            } else if (groupType === 'homeroom') {
                endpoint = `/api/groups/homeroom-groups/${groupId}/`;
            } else {
                // Fallback to old endpoint for backward compatibility
                endpoint = `/api/groups/${groupId}/`;
                if (cteTeacher) {
                    requestConfig.params = { cte_teacher: cteTeacher };
                }
            }

            const response = await axios.delete(endpoint, requestConfig);

            if (response.status === 204) {
                console.log('Group deleted with no content response.');
                onRemove(groupId, []); // Assume no students are returned
            } else if (response.status === 200 && response.data?.success) {
                onRemove(groupId, response.data.removedStudents || []);
            }
        } catch (error) {
            console.error('Error deleting group:', error.message);
            alert('An error occurred while deleting the group.');
        } finally {
            setIsConfirming(false);
        }
    };

    return (
        <div className="remove-group">
            {!isConfirming ? (
                <button
                    className="remove-group-btn"
                    onClick={() => setIsConfirming(true)}
                >
                    Remove
                </button>
            ) : (
                <div className="confirm-remove">
                    <p>Are you sure you want to delete "{groupName}"? This will move all students in the group to unassigned.</p>
                    <button className="confirm-btn" onClick={handleRemove}>
                        Yes, Delete
                    </button>
                    <button
                        className="cancel-btn"
                        onClick={() => setIsConfirming(false)}
                    >
                        Cancel
                    </button>
                </div>
            )}
        </div>
    );
};

export default RemoveGroup;
